import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import configureStore from './redux/configureStore';
import MuiContainer from './container/MuiContainer';
import getRoutes from './routes/index';
import Head from './Head';
import 'normalize.css/normalize.css';
import './styles/index.css';
import './styles/fonts/PxGroteskRegular-Regular.css';
import './styles/transitions/_alert.css';
import './styles/animations/loadingBar.css';

import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

const initialState = window.__INITIAL_STATE__; // eslint-disable-line no-underscore-dangle

const store = configureStore({ initialState, browserHistory });

const history = syncHistoryWithStore(browserHistory, store);

injectTapEventPlugin();

const routes = getRoutes(history);

ReactDOM.render(
	<div>
		<Head />
		<Provider store={store}>
			<MuiContainer>
				{routes}
			</MuiContainer>
		</Provider>
	</div>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js